import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Transition } from 'react-transition-group';
import { TweenMax } from 'gsap';

import ArchetypesMenu from '../ArchetypesMenu';
import Picks from '../Picks';

import PartnershipLogo from '../../PartnershipLogo';

import { restart } from '../../../actions';
// import { hexToRgb, getRandomArbitrary } from '../../../utils/math';
import { track } from '../../../utils/analytics';
import { createMarkup } from '../../../utils/string';

import style from './index.module.scss';

class Archetype extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
      ctaColor: null,
      ctaBackground: null,
      ctaBorder: 'transparent',
      mobileOverride: 'desktop'
    }

    this.animateIn = this.animateIn.bind(this);
    this.animateOut = this.animateOut.bind(this);
    this.handleShareClick = this.handleShareClick.bind(this);
    this.handleCTAMouseOver = this.handleCTAMouseOver.bind(this);
    this.handleCTAMouseOut = this.handleCTAMouseOut.bind(this);
    this.handleMobileOverride = this.handleMobileOverride.bind(this);
  }

  animateIn() {
    const title = this.container.querySelector(`.${style.title}`);
    const description = this.container.querySelector(`.${style.description}`);
    const buttons = this.container.querySelector(`.${style.buttons}`);
    const logo = this.container.querySelector(`.${style.logo}`);
    const picks = this.container.querySelector(`.${style['products-container']}`);
    TweenMax.set([title, description, buttons, logo, picks], { opacity: 0 });
    TweenMax.staggerTo([title, description, buttons, logo, picks], 0.5, { opacity: 1 }, 0.1);
  }

  animateOut() {
    // TweenMax.to(this.description, 1, { opacity: 0, delay: 0 });
  }

  handleCTAMouseOver() {
    const { ctaBackground, ctaColor } = this.state;
    this.setState(() => ({ ctaColor: ctaBackground, ctaBackground: ctaColor }));
  }

  handleCTAMouseOut() {
    const { base: { app }, archetype: { buttonBackground } } = this.props;
    this.setState(() => ({ ctaColor: app.primaryColor, ctaBackground: buttonBackground }));
  }

  handleShareClick() {
    const { dispatch } = this.props;
    dispatch(restart(0));
  }

  handleMobileOverride() {
    const { mobileOverride } = this.state;
    const wWidth = window.innerWidth;
    if (wWidth <= 959 && mobileOverride !== 'mobile') {
      this.setState(() => ({ mobileOverride: 'mobile' }));
    } else if (wWidth > 959 && mobileOverride !== 'desktop') {
      this.setState(() => ({ mobileOverride: 'desktop' }));
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleMobileOverride);
  }

  componentDidMount() {
    const { base: { app }, archetype: { buttonBackground } } = this.props;
    this.setState(() => ({ ctaColor: app.primaryColor, ctaBackground: buttonBackground }));

    this.handleMobileOverride();
    window.addEventListener('resize', this.handleMobileOverride);
  }

  render() {
    const { base: { archetypes, app }, archetype: { personaNumber, personaNameLong, description, products, buttonBackground, legal }, themes, layout: { mobile }, show, onArchetypeChange, result } = this.props;
    if (themes.length < 1) return null;
    const { ctaBackground, ctaColor, mobileOverride } = this.state;
    const theme = themes.filter(theme => theme.themeIndex === +personaNumber)[0];
    const { themeIndex, primaryColor, secondaryColor } = theme;
    // console.log('::::::::::::::: results', theme, this.props, mobileOverride);

    if (isNaN(result)) return null;

    return (
      <Transition
        timeout={0}
        in={show}
        onEnter={() => {
          track('visible', `Result ${personaNameLong}`);
          this.setState(() => ({ active: true }));
        }}
        onExit={() => this.setState(() => ({ active: false }))}
        addEndListener={(node, done) => {
          show ? this.animateIn() : this.animateOut();
        }}
      >
        <div className={`${style.archetype} ${show ? style.active : ''}`} style={{ background: secondaryColor }} ref={instance => this.container = instance}>
          <div className={style.result}>
            <div className={style['upper-content']}>
              <div className={style['background-image']}
                style={{ backgroundImage: `url(${theme.resultBackground.replace('{{platform}}', mobileOverride)})` }}/>
              {mobileOverride === 'mobile'
                ? <div className={style['bottom-wrapper']}>
                  <div className={style['background-bottom']}
                    style={{ backgroundImage: `url(${theme.resultBackground.replace('{{platform}}', 'bottom').replace('jpg', 'png')})` }} />
                  </div>
                : null}
              {/* {mobileOverride === 'mobile' ? <div className={style['background-bottom']}
                style={{ backgroundImage: `url(${theme.resultBackground.replace('{{platform}}', 'bottom').replace('jpg', 'png')})` }} /> : null} */}
              <div className={style['persona-container']}>
                <div className={style.copy} style={{ color: app.primaryColor }}>
                  <div className={style.title}>
                    {mobile
                      ?
                      <Fragment>
                        <div className={`${style.type} ${style.label}`}>{`You are...`}</div>
                        <div className={`${style.type} ${style.persona}`}>{personaNameLong}</div>
                      </Fragment>
                      :
                      <div className={style.type}>
                        <span className={style.label}>{`You are...`}</span>
                        <span className={style.persona}> {personaNameLong}</span>
                      </div>}
                  </div>
                  <div className={style.description} ref={instance => this.description = instance} dangerouslySetInnerHTML={createMarkup(description)} />
                  <div className={style.buttons}>
                    <div className={style['restart-button']} onMouseOver={this.handleCTAMouseOver} onMouseOut={this.handleCTAMouseOut} onClick={this.handleShareClick} style={{ color: ctaColor, background: ctaBackground }}>RESTART QUIZ</div>
                    <div className={style['archetypes-button']} style={{ background: buttonBackground }}>
                      <ArchetypesMenu show={show} color={theme.menuColor} archetypes={archetypes} highlight={secondaryColor} result={result} onArchetypeChange={onArchetypeChange.bind(this)} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={style['bottom-content']}> 
              {/* {!mobile ? */}
                <div className={style['bottom-group']}>
                  <div className={style.legal}>{legal}</div>
                  <PartnershipLogo show={show} className={`${style.logo} ${style.white}`} color={'white'} animate={false} />
                </div>
              {/* : null} */}
            </div>
            <div className={style['products-container']} style={{ backgroundColor: primaryColor }}>
              {/* {mobile ? <PartnershipLogo show={show} className={style.logo} color={'white'} stacked={false} /> : null} */}
              <div className={style.products}>
                <Picks show={show} products={products} primaryColor={app.primaryColor} shape={theme.shape} />
              </div>
            </div>
          </div>
        </div>
      </Transition>
    )
  }
}

const mapStateToProps = state => ({
  view: state.view,
  quiz: state.quiz,
  base: state.base,
  themes: state.themes,
  layout: state.layout
})

export default connect(mapStateToProps)(Archetype);
